#import "../fragments/user-fragment.graphql"

query GetUser($id: ID!) {
    user(id: $id) {
        ...User
    }
}
